import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AnalyticsService } from '../_services/analytics.service';

/**
 * Angular catches errors thrown inside components, pipes and subscriptions and routes them
 * here instead of letting them reach `window.onerror`. PostHog's own `capture_exceptions`
 * only sees the latter, so without this handler the majority of real customer-facing errors
 * never reach Error Tracking.
 *
 * AnalyticsService is resolved lazily via Injector — injecting it directly creates a cyclic
 * dependency at bootstrap (ErrorHandler is constructed before the app's providers are ready).
 */
@Injectable()
export class PosthogErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(error: any): void {
    // Keep the default behaviour — the console is still where developers look first.
    console.error(error);

    try {
      const analytics = this.injector.get(AnalyticsService);
      analytics.captureException(this.unwrap(error), {
        source: 'angular_error_handler',
        url: window.location.href
      });
    } catch (e) { }
  }

  /** Angular wraps errors from promises/observables — report the original cause. */
  private unwrap(error: any): any {
    return (error && error.rejection) || (error && error.originalError) || error;
  }
}
